import { FC } from 'react';

import { IconType } from 'react-icons';

import Link from 'next/link';

import { TColorProp, useTheme } from 'styled-components';
import { PopperPlacementType, Tooltip } from '@mui/material';

import { Wrapper } from './styles';

interface ICircleIconButtonProps {
  tooltip?: string;
  tooltipPlacement?: PopperPlacementType;
  hoverFilterBackground?: boolean;
  backgroundColor?: string;
  size?: number;
  iconColor?: TColorProp;
  iconSize?: number;
  disabled?: boolean;
  href?: string;
  icon: IconType;
  onClick?: () => void;
}
export const CircleIconButton: FC<ICircleIconButtonProps> = ({
  tooltip,
  tooltipPlacement = 'auto',
  iconColor = 'neutral600',
  hoverFilterBackground = false,
  disabled = false,
  backgroundColor,
  size = 40,
  iconSize = 20,
  href,
  icon: Icon,
  onClick,
}) => {
  const theme = useTheme();

  const content = <Icon size={iconSize} color={theme[iconColor]} />;

  return (
    <Tooltip title={tooltip} arrow placement={tooltipPlacement}>
      <Wrapper
        onClick={onClick}
        size={size}
        hoverFilterBackground={hoverFilterBackground}
        backgroundColor={backgroundColor}
        disabled={disabled}
      >
        {href ? (
          <Link
            href={href}
            style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          >
            {content}
          </Link>
        ) : (
          content
        )}
      </Wrapper>
    </Tooltip>
  );
};
